<template>
<v-row no-gutters>
    <v-col v-bind="labelCols">
        <slot name="label" :id="id">
            <v-label :for="id" class="text-body-2 text-grey-darken-1 font-weight-bold" :class="{'mt-0': noMarginLabel}">
                {{ label }}:<span v-if="required" class="ml-1 font-weight-bold text-red">*</span>
            </v-label>
            <client-only v-if="!!tooltip">
                <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" class="tooltip-activator" :icon="mdiInformationOutline" color="orange" size="16"></v-icon>
                    </template>

                    <div class="text-black" v-html="tooltip"></div>
                </v-tooltip>
            </client-only>
        </slot>
    </v-col>
    <v-col v-bind="inputCols">
        <slot name="input" :id="id">
            Sem dej input
        </slot>
    </v-col>
</v-row>
</template>

<script setup>
import {computed, useId} from "vue";
import {mdiInformationOutline} from "@mdi/js";
import ClientOnly from "../../components/ClientOnly.vue";

const props = defineProps({
    labelCols: {
        type: Object,
        default: {
            cols: 12,
            md: 6,
            lg: 4
        }
    },
    label: String,
    tooltip: String,
    noMarginLabel: Boolean,
    id: [String, Number],
    required: Boolean,
    inputCols: {
        type: Object,
        default: {
            cols: 12,
            md: 6,
            lg: 4
        }
    }
})

const uid = useId();
const id = computed(() => props.id || `input-${uid}`);
</script>

<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
:deep(.v-label){
    --v-medium-emphasis-opacity: 1;
    margin-top: 15px;
}
:deep(.v-field){
    font-size: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    input, .v-field__input{
        background-color: white;
    }
    &.v-field--disabled{
        opacity: 1;
        .v-field__overlay{
            background-color: map.get($grey, lighten-5);
        }
    }
    &.v-field--variant-outlined{
        .v-field__outline {
            --v-field-border-opacity: .2;
        }
    }
}
</style>
